"use client";

import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { ChevronRightIcon } from "lucide-react";
import { motion } from "motion/react";
import React from "react";
import MotionHighlight from "@/components/effects/MotionHighlight";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { DropdownMenuSubTriggerProps } from "../types";

function DropdownMenuSubTrigger({
  inset,
  disabled,
  className,
  children,
  ...props
}: DropdownMenuSubTriggerProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <MotionHighlight disabled={disabled}>
      <DropdownMenuPrimitive.SubTrigger {...native} disabled={disabled} asChild>
        <motion.div
          data-slot="dropdown-menu-sub-trigger"
          data-inset={inset}
          data-disabled={disabled}
          whileTap={{ scale: 0.95 }}
          className={cn(
            "[&:not([data-highlight])]:focus:bg-accent focus:text-accent-foreground [&:not([data-highlight])]:data-[state=open]:bg-accent data-[state=open]:text-accent-foreground data-[state=open]:[&_[data-chevron]]:rotate-90 [&_[data-chevron]]:transition-transform [&_[data-chevron]]:duration-150 [&_[data-chevron]]:ease-in-out [&_svg:not([class*='text-'])]:text-muted-foreground relative z-[1] flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
            inset && "pl-8",
            className,
            classes,
          )}
        >
          {children}
          <ChevronRightIcon className="ml-auto size-4" />
        </motion.div>
      </DropdownMenuPrimitive.SubTrigger>
    </MotionHighlight>
  );
}

DropdownMenuSubTrigger.displayName = "DropdownMenu.SubTrigger";

export default DropdownMenuSubTrigger;
